'use client'

import * as React from 'react'
import { usePathname } from '@repo/nextjs-utils/navigation'
import { useSiteBanner } from '@repo/analytics/hooks/use-site-data'
import { facebookEvent, FacebookEventName } from '@repo/analytics/facebook'
import { trackPageView } from '@repo/analytics/amplitude/utils'
import { useRouteChangeListener } from './context'

export function RouteChangeListeners({
  skipAmplitudePageViewTracking = false,
}: {
  skipAmplitudePageViewTracking?: boolean
}) {
  const pathname = usePathname()
  const { banner, isFetched: bannerIsFetched } = useSiteBanner()
  const { shouldSkipAmplitudePageViewTracking } = useRouteChangeListener()

  React.useEffect(() => {
    if (!skipAmplitudePageViewTracking && !shouldSkipAmplitudePageViewTracking && bannerIsFetched) {
      trackPageView({
        banner_above_nav:
          banner && 'bannerAboveNav' in banner ? banner.bannerAboveNav : 'no_banner',
        banner_above_nav_state:
          banner && 'bannerAboveNavState' in banner ? banner.bannerAboveNavState : 'no_banner',
      })
    }
  }, [
    pathname,
    skipAmplitudePageViewTracking,
    banner,
    bannerIsFetched,
    shouldSkipAmplitudePageViewTracking,
  ])

  React.useEffect(() => {
    facebookEvent(FacebookEventName.PAGE_VIEW)
  }, [pathname])

  return <></>
}
